export enum MyProceduresRouteNames {
  PROCEDURE_SELECTOR = 'procedure-selector',
  // PROCEDURES TYPES:
  PORTUGAL_CYCLE_CHANGE = 'pt-cycle-change',
  POWER_TARIFF_CHANGE = 'power-tariff-change',
  PORTUGAL_POWER_CHANGE = 'pt-power-change',
  PAYMENT_DEFERMENT = 'payment-deferment',
  INVOICE_CONCEPT = 'invoice-concept',
  PORTUGAL_INVOICE_CONCEPT = 'pt-invoice-concept',
  CANCELLATION = 'cancellation',
  PORTUGAL_CANCELLATION = 'pt-cancellation',
  ACCOUNT_CHANGE = 'account-change',
  PORTUGAL_ACCOUNT_CHANGE = 'pt-account-change',
  INVOICE_ADDRESS_CHANGE = 'invoice-address-change',
  PORTUGAL_CHANGE_BILLING_CONTACTS = 'pt-change-billing-contacts',
  CONCEPTS_DISCREPANCY = 'concepts-discrepancy',
  POWER_DISCREPANCY = 'power-discrepancy',
  PORTUGAL_POWER_DISCREPANCY = 'pt-power-discrepancy',
  MEASUREMENT_DISCREPANCY = 'measurement-discrepancy',
  INVOICE_DELAY = 'invoice-delay',
  PORTUGAL_INVOICE_DELAY = 'pt-invoice-delay',
  OUTAGES_FAILURES = 'outages-failures',
  MEASUREMENT_FILE_INCIDENCE = 'measurement-file-incidence',
  PORTUGAL_MEASUREMENT_FILE_INCIDENCE = 'pt-measurement-file-incidence',
  SELF_CONSUMPTION_CHANGE = 'self-consumption-change',
  HOLDER_CHANGE = 'holder-change',
  PORTUGAL_OUTAGES_FAILURES = 'pt-outages-failures',
  PORTUGAL_HOLDER_CHANGE = 'pt-holder-change',
  PORTUGAL_METER_READING = 'pt-meter-reading',
}
